import {trashSvg as Icon__small__trashSvg} from '../Icon__small/Icon__small--trash.js';
import {trashSvg as Icon__xsmall__trashSvg} from '../Icon__xsmall/Icon__xsmall--trash.js';

export var trash = {
  name: 'trash',
  category: 'icon',
  colorable: true,
  svg: Icon__small__trashSvg,
  alt: {
    Icon__small: Icon__small__trashSvg,
    Icon__xsmall: Icon__xsmall__trashSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
